export default () => {
    $('.imageGallery')
        .on('jcarousel:create jcarousel:reload', function () {
            const element = $(this);
            const width = element.innerWidth();
            element.jcarousel('items').css('width', `${width}px`);
        })
        .jcarousel();

    $('.imageGallery-pagination').jcarouselPagination({
        item(page, $image) {
            return `<span style="background-image:url(${$image.data('preview')})"> </span>`;
        },
    });

    $('.imageGallery-pagination')
        .on('jcarouselpagination:active', 'span', function () {
            $(this).addClass('active');
        })
        .on('jcarouselpagination:inactive', 'span', function () {
            $(this).removeClass('active');
        });

    if (!$('.imageGallery-pagination span.active').length) {
        $('.imageGallery-pagination span:first-child').addClass('active');
    }
};